import React, {useEffect, useState, useRef, useContext} from "react";
import {store} from '../context/store';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";


import {LICENCE_KEY} from "../constants/charts";

//am4core.useTheme(am4themes_animated);
am4core.addLicense(LICENCE_KEY);

export default function AmChartSimpleLine({chartId, width, height, chartData, graphs, isStacked, categoryKey, isStack100}){

	const chart = useRef(null);
	const globalState = useContext(store);
	
	useEffect(() => {
		
		let x = am4core.create(chartId, am4charts.XYChart);
		
		x.paddingRight = 20;
		x.stroke = "#666";
		x.strokeWeight = 0;
		x.strokeOpacity = 0;
  
    x.fontSize = 11;
    x.fill="black";
    x.strokeAlpha=0;
    
  
		let categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category=categoryKey;	
		
		
		categoryAxis.renderer.minGridDistance = 15;
		categoryAxis.strokeWidth=0;
		categoryAxis.renderer.grid.template.strokeOpacity = 0;
		categoryAxis.renderer.grid.template.strokeDasharray = "1,3";
		categoryAxis.renderer.axisFills.template.fillOpacity = 0.15;
		
		categoryAxis.renderer.labels.template.fontSize=9;
		categoryAxis.renderer.labels.template.strokeOpacity=0;
		categoryAxis.renderer.labels.template.fillOpacity=1;
		categoryAxis.renderer.labels.template.fill='black';
		categoryAxis.renderer.labels.template.rotation=-90;
		
		categoryAxis.renderer.axisFills.template.disabled = false;
		categoryAxis.renderer.axisFills.template.fillOpacity = 0.05;
		categoryAxis.renderer.axisFills.template.fill = 'black';
		categoryAxis.renderer.axisFills.template.strokeOpacity = 0;
    
		let valueAxis = x.yAxes.push(new am4charts.ValueAxis());
 		valueAxis.strokeWidth=0;
 		valueAxis.renderer.labels.template.strokeOpacity=0;
		valueAxis.renderer.labels.template.fillOpacity=1;
		valueAxis.renderer.labels.template.fill='black';
		
		if(isStack100){
			valueAxis.min=0;
			valueAxis.max=100;
			valueAxis.strictMinMax=true;
			valueAxis.percent=true;
		}
 		
 		for(let i=0; i<graphs.length; i++){
	 		let series = x.series.push(new am4charts.LineSeries());
	 		series.name = graphs[i].title;
	    series.dataFields.categoryX = categoryKey;
	    series.dataFields.valueY = graphs[i].keyColumn;
	    
	    series.tensionX = 0.8;
	    
	    series.tooltipText = graphs[i].title + " ({categoryX}): {valueY}";
  		series.tooltip.label.wrap=true;
  		series.tooltip.label.width=300;
  		series.tooltip.label.fill='black';
  		
  		if(graphs[i].color){
	    		series.fill = graphs[i].color;
	    		series.stroke = graphs[i].color;
	    	}
	    
	    if(isStacked){
	    	series.fillOpacity = 0.7;
	    	series.stacked = true;
	    	series.strokeWidth=1;
	    	if(graphs[i].color){
	    		series.fill = graphs[i].color;
	    		series.stroke = graphs[i].color;
	    	}
	    }
	    else{
		    let bullet = series.bullets.push(new am4charts.CircleBullet());
		    //bullet.fill = new am4core.InterfaceColorSet().getFor("background");
		    bullet.fillOpacity = 1;
		    bullet.strokeWidth = 2;
		    bullet.circle.radius = 3;
		    bullet.circle.strokeWidth = 2;
		    series.strokeWidth=2;
		  }
    }
    
    let legend = new am4charts.Legend();
  	legend.labels.template.strokeOpacity=0; 
  	legend.labels.template.fillOpacity=1; 
  	legend.labels.template.fill='black'; 
  	legend.useDefaultMarker = true;
  	
  	
  	x.legend = legend;
    x.cursor = new am4charts.XYCursor();
    x.numberFormatter.numberFormat = "#.00a";
		x.numberFormatter.bigNumberPrefixes = [
			{"number":1e+3, "suffix":"K"},
			{"number":1e+6, "suffix":"M"},
			{"number":1e+9, "suffix":"Bn"}
		];
		
		x.data = chartData;
		let scrollbar = new am4core.Scrollbar();
		scrollbar.opacity = 0.2;
		x.scrollbarX = scrollbar;
		chart.current = x;
		
		return () => {
			x.dispose();
		};
		
	}, [chartId, chartData, graphs]);
	
		
	return (
		<div id={chartId} style={{ width: width, height: height}}></div>
	);
}